__turbopack_context__.v({
  "load_more_button": "OMgm4q_load_more_button",
  "loading_indicator": "OMgm4q_loading_indicator",
  "results": "OMgm4q_results",
  "results_text_header": "OMgm4q_results_text_header",
  "results_text_small": "OMgm4q_results_text_small",
});
